/**
 * PageSidebar - Publish settings and SEO configuration sidebar
 */
export const PagePublishSettings = ({ form, setForm }) => {
  return (
    <div className="bg-zinc-900/50 border border-white/10 p-6 space-y-4">
      <h3 className="text-xs font-bold uppercase text-zinc-400">Publish</h3>
      <label className="flex items-center gap-3 cursor-pointer">
        <input
          type="checkbox"
          checked={form.is_published}
          onChange={(e) => setForm({ ...form, is_published: e.target.checked })}
          className="w-4 h-4"
        />
        <span className="text-white">Published</span>
      </label>
      <label className="flex items-center gap-3 cursor-pointer">
        <input
          type="checkbox"
          checked={form.show_in_menu}
          onChange={(e) => setForm({ ...form, show_in_menu: e.target.checked })}
          className="w-4 h-4"
        />
        <span className="text-white">Show in Menu</span>
      </label>
    </div>
  );
};

export const PageSEOSettings = ({ form, setForm }) => {
  return (
    <div className="bg-zinc-900/50 border border-white/10 p-6 space-y-4">
      <h3 className="text-xs font-bold uppercase text-zinc-400">SEO</h3>
      <div>
        <label className="block text-xs text-zinc-500 mb-2">Page Title</label>
        <input
          type="text"
          value={form.page_title}
          onChange={(e) => setForm({ ...form, page_title: e.target.value })}
          placeholder={form.title}
          className="w-full bg-black border border-white/10 text-white px-3 py-2 text-sm"
        />
      </div>
      <div>
        <label className="block text-xs text-zinc-500 mb-2">Meta Description</label>
        <textarea
          value={form.meta_description}
          onChange={(e) => setForm({ ...form, meta_description: e.target.value })}
          rows={3}
          className="w-full bg-black border border-white/10 text-white px-3 py-2 text-sm resize-none"
        />
      </div>
      <div>
        <label className="block text-xs text-zinc-500 mb-2">OG Image URL</label>
        <input
          type="url"
          value={form.og_image}
          onChange={(e) => setForm({ ...form, og_image: e.target.value })}
          className="w-full bg-black border border-white/10 text-white px-3 py-2 text-sm"
        />
      </div>
    </div>
  );
};

export default PagePublishSettings;
